module.exports = __webpack_public_path__ + "img/logo.d3b0f342.svg";